import pluralize from 'pluralize-ru';
import { Id } from './types';

const pluralizeCost = (value: Id) =>
  pluralize(
    value,
    '%d рублей в месяц',
    '%d рубль в месяц',
    '%d рубля в месяц',
    '%d рублей в месяц',
  );

export default pluralizeCost;



// WEBPACK FOOTER //
// ./src/services/financigservice/utils/costPluralize.ts